import { render } from "./CoreUserStats.vue?vue&type=template&id=33037da2"
import script from "./CoreUserStats.vue?vue&type=script&lang=js"
export * from "./CoreUserStats.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CoreUserStats.vue?vue&type=style&index=0&id=33037da2&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__